module.exports = __webpack_public_path__ + "img/TCC-L6-Pagina2 A.17136c16.png";